module.exports = __webpack_public_path__ + "static/media/promo.7683f242.png";